import React, { useState } from "react";
import useFrequencyToggle from "../hooks/useFrequencyToggle";
import "./FrequencyToggle.scss";
export default function FrequencyToggle({ isMiniCart }) {
  const { onToggle, frequency, onceIsActive, monthlyIsActive, isLoading } =
    useFrequencyToggle();

  return (
    <fieldset
      onChange={onToggle}
      disabled={isLoading}
      className={`frequency-toggle ${
        frequency && !isLoading ? "" : "is-disabled"
      } ${(isMiniCart && "frequency-toggle--mini") || ""}`}
    >
      <label className={`pill pill--once ${onceIsActive}`}>
        Give Once
        <input
          type="radio"
          name="frequency"
          value="once"
          className="visually-hidden"
        />
      </label>
      <label className={`pill pill--monthly ${monthlyIsActive}`}>
        Give Monthly
        <input
          type="radio"
          name="frequency"
          value="monthly"
          className="visually-hidden"
        />
      </label>
      <div className={`pill-bg ${frequency}`}></div>
    </fieldset>
  );
}
